/**
 * Extend the core swatch renderer widget, adding the ability to render the custom size swatch
 */
define([
    'jquery',
    'sizeSwatchSwitcher',
    'mageSwatchRenderer',
    'sizeChart',
    'sizeStockChecker'
], ($, sizeSwatchSwitcher) => {
    $.widget('munro.SwatchRenderer', $.mage.SwatchRenderer, {

        /**
         * Event listener
         *
         * @private
         */
        _EventListener() {
            const $widget = this;

            $widget._super();
        },

        /**
         * Render controls
         *
         * @private
         */
        _RenderControls() {
            const $widget = this;


            const container = this.element;


            const { classes } = this.options;


            const { chooseText } = this.options.jsonConfig;

            $widget.optionsMap = {};

            // Attaching this event listener here so that it's available if the sizing system displayed needs to be updated
            //$widget.element.on('change', `.${this.options.classes.attributeInput}`, $widget.updateSelectedSku);

            // Temp fix for to test add to cart
            $widget.element.on('change', `.${this.options.classes.attributeInput}`, function () {
                const $parent = $('#product_addtocart_form .swatch-attribute');
                const $input = $parent.find('.swatch-input');
                let optionId = $('#product_addtocart_form').find('.swatch-option.selected').attr('option-id');
                optionId = parseInt(optionId);
                if (optionId > 0) {
                    $parent.attr('data-option-selected', optionId);
                    $input.val(optionId);
                } else {
                    $parent.removeAttr('data-option-selected');
                    $input.val('');
                }

                return $widget.updateSelectedSku();
            });
-
            $.each(this.options.jsonConfig.attributes, function renderAttributes() {
                const item = this;
                const select = $widget._RenderSwatchSelect(item, chooseText);
                let input = $widget._RenderFormInput(item);
                const label = '';

                const options = (sizeSwatchSwitcher.isSizeSwatch(item)) ? $widget._RenderSizeSwatchOptions(item) : $widget._RenderSwatchOptions(item);

                // Show only swatch controls
                if ($widget.options.onlySwatches && !$widget.options.jsonSwatchConfig.hasOwnProperty(item.id)) {
                    return;
                }

                if ($widget.inProductList) {
                    $widget.productForm.append(input);
                    input = '';
                }

                let sizeSystem = false;
                // Create new control
                let containerClass = '';
                if (sizeSwatchSwitcher.isSizeSwatch(item)) {
                    // Don't assume the first entry is assigned to this store - if it's not,
                    // there won't be an entry in jsonConfig.products, and this will break.
                    // See MMI-325

                    // Find first item that *is also present in jsonConfig.products*.
                    // This guarantees firstItem.products[0] is a valid key for jsonConfig.products
                    //
                    // Note: tried to use Object.values and .find, but that breaks in IE 11,
                    // so reverted to this version
                    var firstItem = null;
                    for (var myKey in Object.keys(item.options)) {
                        if (item.options[myKey].products.length === 0) {
                            continue;
                        }
                        firstItem = item.options[myKey];
                    }
                    if (firstItem === null) {
                        throw "This should never happen MMI-325";
                    }

                    const originalSize = $widget.options.jsonConfig.products[firstItem.products[0]].original_size;
                    const sizeSystemOptions = sizeSwatchSwitcher.getAllSizeSystemOptions(
                        sizeSwatchSwitcher.getSizeGender(originalSize)
                    );
                    container.append(
                        `<select class="size-switcher">${sizeSystemOptions}</select>
                        <a href="#" class="product__sizing-size-guide--link" data-sizing-guide-trigger>
                            View Size Guide
                        </a>
                        <input type="hidden" id="selected_simple_product_sku" />`
                    );

                    containerClass = sizeSwatchSwitcher.getSizeGender(originalSize);
                    // Assuming that if one size is male, then all sizes are male
                    if (sizeSwatchSwitcher.isMaleSize(originalSize)) {
                        // If no default is set, use EU men's as default
                        sizeSystem = 'eum';
                    } else if (sizeSwatchSwitcher.isBoysSize(originalSize)) {
                        sizeSystem = 'kkm';
                    } else if (sizeSwatchSwitcher.isGirlsSize(originalSize)) {
                        sizeSystem = 'kfs';
                    } else if (sizeSwatchSwitcher.isFemaleSize(originalSize)) {
                        sizeSystem = 'euw';
                    } else if (sizeSwatchSwitcher.isKidsSize(originalSize)) {
                        sizeSystem = 'euc';
                    }


                    if (typeof $widget.options.jsonConfig.default_size_system !== 'undefined') {
                        sizeSystem = $widget.options.jsonConfig.default_size_system;
                    }
                }
                container.append(
                    `<div
                        data-swatch-filters-container="${containerClass}"
                        class="filter-size ${classes.attributeClass} ${item.code} ${containerClass}"
                        data-attribute-code="${item.code}"
                        data-attribute-id="${item.id}"
                        data-option-selected="">
                        ${label}
                        <div class="${classes.attributeOptionsWrapper} clearfix">
                            ${options}
                            ${select}
                        </div>
                        ${input}
                    </div>`
                );

                if (sizeSystem !== false) {
                    sizeSwatchSwitcher.selectSizeSystem(sizeSystem);
                }

                $widget.optionsMap[item.id] = {};

                // Aggregate options array to hash (key => value)
                $.each(item.options, function parseProducts() {
                    if (this.products.length > 0) {
                        $widget.optionsMap[item.id][this.id] = {
                            price: parseInt(
                                $widget.options.jsonConfig.optionPrices[this.products[0]].finalPrice.amount,
                                10
                            ),
                            products: this.products
                        };
                    }
                });
            });

            // Hide all elements below more button
            $(`.${classes.moreButton}`).nextAll().hide();

            // Handle events like click or change
            $widget._EventListener();

            // Rewind options
            $widget._Rewind(container);

            // Emulate click on all swatches from Request
            $widget._EmulateSelected($.parseQuery());
            $widget._EmulateSelected($widget._getSelectedAttributes());
        },

        /**
         * Render the size swatches
         *
         * @param config
         *
         * @returns {string}
         * @private
         */
        _RenderSizeSwatchOptions(config) {
            const $widget = this;


            const optionConfig = this.options.jsonSwatchConfig[config.id];


            const { optionClass } = this.options.classes;


            const moreLimit = parseInt(this.options.numberToShow, 10);


            const moreClass = this.options.classes.moreButton;


            const moreText = this.options.moreButtonText;


            let countAttributes = 0;


            let html = '';

            if (!this.options.jsonSwatchConfig.hasOwnProperty(config.id)) {
                return '';
            }

            window.productIdSkus = $widget.mapProductIdToSku($widget.options.jsonConfig.products, $widget.options.jsonConfig.index, config.id);


            $.each(config.options, function renderOption() {

                if (!optionConfig.hasOwnProperty(this.id)) {
                    return '';
                }

                // Add more button
                if (moreLimit === countAttributes++) {
                    html += `<a href="#" class="${moreClass}">${moreText}</a>`;
                }

                const { id } = this;
                const type = parseInt(optionConfig[id].type, 10);
                const value = optionConfig[id].hasOwnProperty('value') ? optionConfig[id].value : '';
                const thumb = optionConfig[id].hasOwnProperty('thumb') ? optionConfig[id].thumb : '';
                const label = this.label ? this.label : '';
                let attr = `
                    option-type="${type}"
                    option-id="${id}"
                    option-label="${label}"
                    option-tooltip-thumb="${thumb}"
                    option-tooltip-value="${value}"
                `;

                // If the SKU has been mapped to the swatch ID, add it as a data attribute
                // If it hasn't been mapped, then that means there is no stock for that product
                if (window.productIdSkus[id]) {
                    attr += `data-product-sku="${window.productIdSkus[id].sku}"`;
                }

                if (!this.hasOwnProperty('products') || this.products.length <= 0) {
                    attr += ' option-empty="true"';
                }

                // Get the alternate sizes from sizeChartData
                const alternateSizes = sizeSwatchSwitcher.getSizingSystemAlternates(id);

                let outOfStock = '';
                if (optionConfig[id].qty === 0) {
                    outOfStock = 'out-of-stock';
                }

                // Create the data-* attributes with each alternate size for this current size option
                let dataAttributes = '';
                if (typeof alternateSizes !== 'undefined') {
                    const sizingSystems = Object.keys(alternateSizes);
                    $.each(sizingSystems, (index, sizingSystem) => {
                        dataAttributes += ` data-${sizingSystem.toLowerCase()}="${alternateSizes[sizingSystem]}"`;
                    });
                } else {
                    const $swatchOpt = $('.swatch-opt');
                    $swatchOpt.hide();
                }

                html += `<div class="${optionClass} text ${outOfStock}" ${dataAttributes} ${attr}>${value || label
                }</div>`;
            });

            return html;
        },

        /**
         * Returns object that maps the ID of each swatch to the Sku
         *
         * This is required so that the SKU for the simple product represented by a swatch can be populated
         * into a hidden field, for Borderfree to read
         *
         * @param {Object} products    An object containing simple product ID keys and Sku values
         * @param {Object} index       An object containing simple product ID keys and attribute id > swatch id value objects
         * @param {int}    attributeId The attribute ID
         *
         * @returns {Array}
         */
        mapProductIdToSku(products, index, attributeId) {
            const idMap = [];

            $.each(products, (productId, sku) => {
                if (index[productId]) {
                    const swatchId = index[productId][attributeId];
                    idMap[swatchId] = sku;
                }
            });

            return idMap;
        },

        /**
         * Update a hidden input with the SKU value of the simple product corresponding to the swatch that is selected
         *
         * @returns {boolean|null}
         */
        updateSelectedSku() {
            // Check that there is mapping avaialable
            if (!window.productIdSkus || !window.productIdSkus[this.value]) {
                return false;
            }

            // Update the data attribute to indicate the SKU of the simple product that is selected
            // $(this).closest(".swatch-attribute").attr('data-selected-sku', window.productIdSkus[this.value].sku);
            $('#selected_simple_product_sku').val(window.productIdSkus[this.value].sku);
        }
    });

    return $.munro.SwatchRenderer;
});
